// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2biKM","row":"Node_row__3p_Qu","label":"Node_label__3wQvG","footer":"Node_footer__2XfSs"};